import React, { useContext } from 'react';
import { Outlet } from 'react-router';
import PropTypes from 'prop-types';
import Alert from '@Components/Alert';
import { LocalizationContext } from '../../services/localization';
import LoadingSpinner from '@Components/LoadingSpinner';
import useGift from './hooks/useGift';
import useGiftDetails from './hooks/useGiftDetails';
import Footer from 'components/common/Footer';
import EntryFooter from 'components/Home/components/Footer';
import { useGiftCompliance } from './hooks/useGiftCompliance';
import { useGiftReview } from './hooks/useGiftReview';
import { useGiftSuccess } from './hooks/useGiftSuccess';
import { useGiftOccasion } from './hooks/useGiftOccasion';
import './styles/gift.scss';

export default function Gift({ locale, settings, params, bodyRef, loadLocale }) {
  const localized = useContext(LocalizationContext);
  const { flatProcessFee, percentageProcessFee, isGiftingOccasionEnabled } = settings || {};

  const {
    isDataLoading,
    isGiftEntryPage,
    isReviewPage,
    alertProps,
    beneficiary,
    setAlertProps,
    setIsDataLoading,
    setBeneficiary,
    message,
    severity,
    onGiftNowClick
  } = useGift({ location, params, bodyRef, loadLocale, isGiftingOccasionEnabled });

  const {
    relationship,
    relationshipError,
    updateRelationship,
    onComplianceNext,
    validateRelationshipForm
  } = useGiftCompliance();

  const {
    isSubmitLoading,
    selectedGiftAmount,
    checkoutMessage,
    giftOptions,
    isAmountEmptyMessage,
    amountError,
    messageError,
    totalProcessingFee,
    selectedGiftOption,
    updateMessage,
    updateGiftAmount,
    setSelectedGiftAmount,
    onDetailsNext,
    updateGiftOption,
    validateDetailsForm
  } = useGiftDetails({ localized, setAlertProps, flatProcessFee, percentageProcessFee });

  const {
    selectedOccasion,
    setSelectedOccasion,
    continueToDetails,
    occasionOptions
  } = useGiftOccasion({ localized });

  const {
    submitCheckout,
    isPaymentLoading
  } = useGiftReview({
    selectedGiftAmount,
    checkoutMessage,
    relationship,
    validateDetailsForm,
    validateRelationshipForm,
    setAlertProps,
    locale,
    selectedOccasion
  });

  const {
    onSuccessDoneClick
  } = useGiftSuccess();

  const routeContextProps = {
    locale,
    localized,
    location,
    params,
    alertProps,
    beneficiary,
    relationship,
    relationshipError,
    setAlertProps,
    setBeneficiary,
    setIsDataLoading,
    isDataLoading,
    isPaymentLoading,
    onGiftNowClick,
    onComplianceNext,
    updateRelationship,
    selectedGiftAmount,
    setSelectedGiftAmount,
    totalProcessingFee,
    checkoutMessage,
    giftOptions,
    isSubmitLoading,
    isAmountEmptyMessage,
    amountError,
    messageError,
    updateMessage,
    updateGiftAmount,
    submitCheckout,
    onDetailsNext,
    message,
    severity,
    updateGiftOption,
    selectedGiftOption,
    validateRelationshipForm,
    validateDetailsForm,
    onSuccessDoneClick,
    selectedOccasion,
    setSelectedOccasion,
    continueToDetails,
    occasionOptions,
    isGiftingOccasionEnabled
  };

  return (
    <div className='gift'>
      {message && (
        <Alert className='gift__error' severity={severity}>
          {localized[message]}
        </Alert>
      )}
       {isDataLoading
        ? <LoadingSpinner />
        : <div className={`
            gift__content-wrapper
            ${isReviewPage ? 'gift__content-wrapper--review' : ''}
          `}>
            <Outlet context={routeContextProps} />
          </div>
       }
      {!isDataLoading && !isReviewPage ? (
          !isGiftEntryPage ? <Footer /> : <EntryFooter/>
        )
      : <></>}
    </div>
  );
}

Gift.propTypes = {
  locale: PropTypes.string,
  settings: PropTypes.object,
  params: PropTypes.object,
  bodyRef: PropTypes.object,
  loadLocale: PropTypes.func
};
